import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";

import ChartOnlineOffline from "./ChartOnlineOffline";
import MiniDataGrid from "./MiniDataGrid";
import ObjectDetails from "./ObjectDetails";
import SensorStatusPieCharts from "./SensorStatusPieCharts";
import VendaiSaleTables from "./VendaiSaleTables";
import { getCurrentTenant } from "../../config/tenantConfig";

export default function MainGridDashboard() {
  const isRcu = getCurrentTenant().projectCode === "RCU";

  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        <Grid size={{ xs: 12, lg: 3 }}>
          <Grid size={12}>
            <ChartOnlineOffline />
          </Grid>
          <Grid size={12} sx={{ marginTop: 2 }}>
            <MiniDataGrid />
          </Grid>
        </Grid>
        <Grid size={{ xs: 12, lg: 8 }}>
          {isRcu && <SensorStatusPieCharts />}
          {/* Toplam Satış + Satış Adeti: VendaiTimePeriodSaleTable/3 endpoint'inden.
              RCU su arıtma tenant'ında satış anlamsız → gizli. Eski "table" widget'ları ObjectDetails'te gizlenir. */}
          {!isRcu && <VendaiSaleTables periodId={3} />}
          <ObjectDetails excludeWidgetTypes={["table"]} />
        </Grid>
      </Grid>
    </Box>
  );
}
